var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEvtLiveAlarm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FA5500",
  d: "m15.045 12.525-1.338-2.109a.96.96 0 0 1-.15-.516V6.75c0-2.357-1.946-4.275-4.338-4.275S4.881 4.393 4.881 6.75V9.9a.96.96 0 0 1-.15.516l-1.338 2.109zm.412.975H2.98c-.598 0-.962-.648-.645-1.148L3.892 9.9V6.75c0-2.9 2.385-5.25 5.327-5.25s5.327 2.35 5.327 5.25V9.9l1.556 2.452c.317.5-.047 1.148-.645 1.148"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FA5500",
  fillRule: "evenodd",
  d: "M6.865 12.746a.5.5 0 0 1 .354-.146h4a.5.5 0 0 1 .5.5c0 .376-.055.75-.163 1.103-.108.352-.269.68-.477.962a2.4 2.4 0 0 1-.759.68 1.94 1.94 0 0 1-.952.255h-.299c-.68 0-1.289-.366-1.71-.935-.42-.567-.64-1.31-.64-2.065a.5.5 0 0 1 .146-.354m.898.854c.067.374.207.71.4.97.273.368.605.53.906.53h.299q.231.002.464-.127a1.4 1.4 0 0 0 .443-.403 2.2 2.2 0 0 0 .325-.66q.046-.15.075-.31z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FA5500",
  d: "M1.219 7.621C.5 5.5 1.501 1.5 4.952.5M17.581 7.621C18.3 5.5 17.299 1.5 13.848.5"
})));
export default SvgIconEvtLiveAlarm;